// @ts-nocheck
// This component can be used to crop the image...

import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Cropper, { centerCrop, makeAspectCrop } from "react-image-crop";
// import Cropper from "react-easy-crop";

// utils
import PropTypes from "prop-types";

import "react-image-crop/dist/ReactCrop.css";

const ImageCropper = ({
  open,
  onClose,
  image,
  onComplete,
  containerStyle,
  src,
  ...props
}) => {
  const TO_RADIANS = Math.PI / 180;

  const previewCanvasRef = React.useRef(null);
  const imgRef = React.useRef(null);
  const hiddenAnchorRef = React.useRef(null);
  const blobUrlRef = React.useRef("");

  // const [crop, setCrop] = React.useState({ x: 0, y: 0 });
  const [crop, setCrop] = React.useState();
  const [completedCrop, setCompletedCrop] = React.useState();
  const [aspect, setAspect] = React.useState(undefined);
  const [rotate, setRotate] = React.useState(0);
  const [scale, setScale] = React.useState(1);
  const [zoom, setZoom] = React.useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null);

  const [localImage, setLocalImage] = React.useState(null);

  function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(
      makeAspectCrop(
        {
          unit: "%",
          width: 90,
        },
        aspect,
        mediaWidth,
        mediaHeight,
      ),
      mediaWidth,
      mediaHeight,
    );
  }

  function onImageLoad(e) {
    if (aspect) {
      const { width, height } = e.currentTarget;
      setCrop(centerAspectCrop(width, height, aspect));
    }
  }

  async function canvasPreview(image, canvas, crop, scale = 1, rotate = 0) {
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      throw new Error("No 2d context");
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    // devicePixelRatio slightly increases sharpness on retina devices
    // at the expense of slightly slower render times and needing to
    // size the image back down if you want to download/upload and be
    // true to the images natural size.
    const pixelRatio = window.devicePixelRatio;
    // const pixelRatio = 1

    canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
    canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = "high";

    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;

    const rotateRads = rotate * TO_RADIANS;
    const centerX = image.naturalWidth / 2;
    const centerY = image.naturalHeight / 2;

    ctx.save();

    // 5) Move the crop origin to the canvas origin (0,0)
    ctx.translate(-cropX, -cropY);
    // 4) Move the origin to the center of the original position
    ctx.translate(centerX, centerY);
    // 3) Rotate around the origin
    ctx.rotate(rotateRads);
    // 2) Scale the image
    ctx.scale(scale, scale);
    // 1) Move the center of the image to the origin (0,0)
    ctx.translate(-centerX, -centerY);
    ctx.drawImage(
      image,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight,
    );

    ctx.restore();
  }

  async function onImageChange() {
    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;
    if (!image || !previewCanvas || !completedCrop) {
      onComplete(localImage);
    }

    // This will size relative to the uploaded image
    // size. If you want to size according to what they
    // are looking at on screen, remove scaleX + scaleY
    // const scaleX = image.naturalWidth / image.width
    // const scaleY = image.naturalHeight / image.height

    const offscreen = new OffscreenCanvas(
      completedCrop.width,
      completedCrop.height,
    );
    const ctx = offscreen.getContext("2d");
    if (!ctx) {
      throw new Error("No 2d context");
    }

    ctx.drawImage(
      previewCanvas,
      0,
      0,
      previewCanvas.width,
      previewCanvas.height,
      0,
      0,
      offscreen.width,
      offscreen.height,
    );
    // You might want { type: "image/jpeg", quality: <0 to 1> } to
    // reduce image size
    const blob = await offscreen.convertToBlob({
      type: "image/*",
    });

    onComplete(blob);

    // if (blobUrlRef.current) {
    //   URL.revokeObjectURL(blobUrlRef.current)
    // }
    // blobUrlRef.current = URL.createObjectURL(blob)

    // if (hiddenAnchorRef.current) {
    //   hiddenAnchorRef.current.href = blobUrlRef.current
    //   hiddenAnchorRef.current.click()
    // }

    // if (blobUrlRef.current) {
    //   URL.revokeObjectURL(blobUrlRef.current)
    // }
    // blobUrlRef.current = URL.createObjectURL(blob);

    // setLocalImage(URL.createObjectURL(blob));
    // console.log(blob, "imageblob");

    // if (blobUrlRef.current) {
    //   URL.revokeObjectURL(blobUrlRef.current)
    // }
    // blobUrlRef.current = URL.createObjectURL(blob)

    // if (hiddenAnchorRef.current) {
    //   hiddenAnchorRef.current.href = blobUrlRef.current
    //   hiddenAnchorRef.current.click()
    // }
  }

  const resetSettings = () => {
    setCrop(null);
    setCompletedCrop(null);
    setAspect(undefined);
    setRotate(0);
    setScale(1);
    setZoom(1);
    setCroppedAreaPixels(null);
    setLocalImage(null);
    blobUrlRef.current = null;
  };

  // React.useEffect(() => {
  //   onImageChange();
  // }, [completedCrop]);

  React.useEffect(() => {
    if (image?.blob) {
      setLocalImage(image?.blob);
    }
  }, [image]);

  React.useEffect(() => {
    (async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // We use canvasPreview as it's much faster than imgPreview.
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate,
        );
      }
    })();
  }, [completedCrop, scale, rotate]);

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          border: "1px solid #D175B6",
        },
      }}
    >
      <DialogTitle
        sx={{
          color: "#D175B6",
          backgroundColor: "#000",
        }}
      >
        Crop Image (Select the required part of image)
      </DialogTitle>

      <DialogContent
        sx={{
          backgroundColor: "#000",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "fit-content",
            height: "fit-content",
          }}
        >
          {/* <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={setCrop}
            onCropComplete={(_, croppedAreaPixels) => {
              setCroppedAreaPixels(croppedAreaPixels);
            }}
            onZoomChange={setZoom}
            {...props}
          /> */}
          <Cropper
            crop={crop}
            onChange={(_, percentCrop) => setCrop(percentCrop)}
            onComplete={(c) => {
              setCompletedCrop(c);
            }}
            aspect={aspect}
            // minWidth={400}
            minHeight={100}
            // circularCrop
          >
            <img
              ref={imgRef}
              alt="Crop me"
              src={image?.objectUrl}
              style={{
                width: "500px",
                // height: "500px",
                transform: `scale(${scale}) rotate(${rotate}deg)`,
              }}
              onLoad={onImageLoad}
            />
          </Cropper>

          {completedCrop ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <canvas
                  ref={previewCanvasRef}
                  style={{
                    border: "1px solid black",
                    objectFit: "contain",
                    width: completedCrop.width,
                    height: completedCrop.height,
                    // display: "none"
                  }}
                />
              </div>
              <div>
                {/* <button onClick={onImageChange}>Download Crop</button>
                <div style={{ fontSize: 12, color: '#666' }}>
                  If you get a security error when downloading try opening the
                  Preview in a new tab (icon near top right).
                </div> */}
                <a
                  href="#hidden"
                  ref={hiddenAnchorRef}
                  download
                  style={{
                    position: "absolute",
                    top: "-200vh",
                    visibility: "hidden",
                  }}
                >
                  Hidden download
                </a>
              </div>
            </>
          ) : null}
        </div>
      </DialogContent>

      <DialogActions
        sx={{
          backgroundColor: "#000",
        }}
      >
        <Button
          color="primary"
          onClick={(e) => {
            resetSettings();
            onClose(e);
          }}
        >
          Close
        </Button>

        <Button
          color="primary"
          onClick={() => {
            // onComplete(cropImage(image, croppedAreaPixels, console.log))
            resetSettings();
            onImageChange();
            // onComplete(hiddenAnchorRef.current.href);
          }}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ImageCropper.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  image: PropTypes.object.isRequired,
  onComplete: PropTypes.func.isRequired,
  containerStyle: PropTypes.object,
};

export default ImageCropper;